export const ACTION_TYPES = {
	ADMIN_TABLE_CLEAR_DATA: 'ADMIN_TABLE_CLEAR_DATA',
	ADMIN_TABLE_HEADER_SORT: 'ADMIN_TABLE_HEADER_SORT',
	ADMIN_TABLE_INIT: 'ADMIN_TABLE_INIT',
	ADMIN_TABLE_LOADING: 'ADMIN_TABLE_LOADING',
	ADMIN_TABLE_ROWS: 'ADMIN_TABLE_ROWS',
	ADMIN_TABLE_ROWS_INDEX: 'ADMIN_TABLE_ROWS_INDEX',
	ADMIN_TABLE_ROW_TOGGLE: 'ADMIN_TABLE_ROW_TOGGLE',
	ADMIN_TABLE_ROWS_TOGGLE: 'ADMIN_TABLE_ROWS_TOGGLE',
	ADMIN_TABLE_FILTER_ROWS: 'ADMIN_TABLE_FILTER_ROWS',
};

export const ACTION_FILTER_TYPES = {
	INVALID_INCLUDE: 'INVALID_INCLUDE',
	INVALID_EXCLUDE: 'INVALID_EXCLUDE',
	VALID_INCLUDE: 'VALID_INCLUDE',
	VALID_EXCLUDE: 'VALID_EXCLUDE',
	QUEUE_FILTER_PENDING: 'QUEUE_FILTER_PENDING',
	QUEUE_FILTER_APPLICATION: 'QUEUE_FILTER_APPLICATION',
};
